import { render, staticRenderFns } from "./GuppyChatUserListItem.vue?vue&type=template&id=d1068b70&"
import script from "./GuppyChatUserListItem.vue?vue&type=script&lang=js&"
export * from "./GuppyChatUserListItem.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatUserListItem.vue?vue&type=style&index=0&id=d1068b70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports